import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TEXT_FIELD_STATUS } from '../../../utils/constants';
import { TEXT_FIELD_IS_REQUIRED } from '../../../utils/messages';
import './TextField.scss';

class TextField extends Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    hint: PropTypes.node,
    isRequired: PropTypes.bool,
    specifiedValidator: PropTypes.func,
    errorSign: PropTypes.bool,
    children: PropTypes.element,
    className: PropTypes.string,
    errorText: PropTypes.string,
    status: PropTypes.string,
    isFocused: PropTypes.bool,
    registerField: PropTypes.func,
    changeHandler: PropTypes.func,
    focusHandler: PropTypes.func,
    value: PropTypes.string,
    mask: PropTypes.func,
    floatCount: PropTypes.number,
    disabledView: PropTypes.bool,
    disabled: PropTypes.bool,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    allowNegative: PropTypes.bool,
  };

  static defaultProps = {
    name: '',
    label: '',
    placeholder: '',
    type: 'text',
    hint: '',
    isRequired: false,
    errorSign: false,
    errorText: '',
    status: '',
    isFocused: false,
    children: <React.Fragment />,
    specifiedValidator: () => '',
    registerField: () => {},
    changeHandler: () => {},
    focusHandler: () => {},
    value: '',
    className: '',
    mask: value => value,
    minValue: -Infinity,
    disabled: false,
    disabledView: false,
    maxValue: Infinity,
    floatCount: 2,
    allowNegative: false,
  };

  componentDidMount() {
    const {
      name,
      registerField,
      mask,
      value,
      changeHandler,
      floatCount,
      allowNegative,
    } = this.props;
    registerField({ name, validator: this.standardValidator });
    const nextValue = mask(
      value,
      undefined,
      undefined,
      floatCount,
      undefined,
      undefined,
      allowNegative,
    );
    changeHandler({ value: nextValue, name });
  }

  componentDidUpdate(prevProps) {
    const {
      value,
      mask,
      changeHandler,
      name,
      floatCount,
      allowNegative,
    } = this.props;
    if (prevProps.value !== value && Number(prevProps.value) === 0) {
      const nextValue = mask(
        value,
        undefined,
        undefined,
        floatCount,
        undefined,
        undefined,
        allowNegative,
      );
      changeHandler({ value: nextValue, name });
    }
  }

  standardValidator = (value, optionalValue) => {
    const { isRequired, disabled } = this.props;
    const { specifiedValidator } = this.props;
    const specifiedValidatorValue = specifiedValidator(value, optionalValue);
    let valid = true;
    let errorText = '';
    if (!disabled) {
      if (specifiedValidatorValue.length) {
        valid = false;
        errorText = specifiedValidatorValue;
      }
      if (isRequired && !(value && value.length)) {
        valid = false;
        errorText = TEXT_FIELD_IS_REQUIRED;
      }
    }

    const status = valid ? TEXT_FIELD_STATUS.VALID : TEXT_FIELD_STATUS.INVALID;

    return { status, errorText };
  };

  changeHandler = (e) => {
    const {
      target: { value },
    } = e;
    const {
      changeHandler,
      name,
      mask,
      maxValue,
      floatCount,
      allowNegative,
    } = this.props;
    const nextValue = mask(
      value,
      -Infinity,
      maxValue,
      floatCount,
      undefined,
      undefined,
      allowNegative,
    );
    changeHandler({ value: nextValue, name });
  };

  focusHandler = (e) => {
    const {
      focusHandler, name, mask, floatCount, allowNegative,
    } = this.props;
    const {
      target: { value },
    } = e;
    const nextValue = mask(
      value,
      undefined,
      undefined,
      floatCount,
      undefined,
      undefined,
      allowNegative,
    );
    focusHandler({ isFocused: true, name, value: nextValue });
  };

  blurHandler = (e) => {
    const {
      target: { value },
    } = e;
    const {
      focusHandler,
      name,
      minValue,
      mask,
      floatCount,
      allowNegative,
    } = this.props;
    // console.log(minValue, 'minValueBluer');
    const newValue = mask(
      value,
      minValue,
      undefined,
      floatCount,
      undefined,
      undefined,
      allowNegative,
    );
    focusHandler({ isFocused: false, value: newValue, name });
  };

  render() {
    const {
      name,
      label,
      placeholder,
      type,
      hint,
      errorSign,
      className,
      errorText,
      isFocused,
      status,
      value,
      disabled,
      disabledView,
    } = this.props;
    const textFieldClasses = classNames({
      'text-field-wrapper': true,
      'text-field-completed': status === TEXT_FIELD_STATUS.VALID,
      'text-field-failed': status === TEXT_FIELD_STATUS.INVALID,
      'show-float-label': isFocused || (value && value.length),
      'show-hint': isFocused || status !== TEXT_FIELD_STATUS.INITIAL,
      disabled: disabled || disabledView,
      [`${className}`]: true,
    });
    return (
      <React.Fragment>
        <div className={textFieldClasses}>
          <div className="text-field-float-label">
            <span>{label}</span>
          </div>
          <div className="text-field-input">
            <input
              type={type}
              name={name}
              value={value}
              onFocusCapture={this.focusHandler}
              onBlur={this.blurHandler}
              placeholder={placeholder}
              onChange={this.changeHandler}
              disabled={disabled || disabledView}
            />{' '}
            {errorSign && <span className="text-field-error-sign">!</span>}
            {this.props.children}
          </div>

          <div className="text-field-error-text">
            <span>{errorText}</span>
          </div>
          <div className="text-field-hint-text">
            <span>{hint}</span>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TextField;



// WEBPACK FOOTER //
// ./src/components/_atomic/TextField/TextField.js